"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultOptions = exports.getDefaultOptions = exports.getDefaultJsonOptions = void 0;
// @file Defaults for fetch requests
const types_1 = require("./types");
const defaultOptions = {
  method: types_1.HTTPMethod.get,
  cache: types_1.FetchOptionCache.default,
  redirect: types_1.FetchOptionRedirect.follow,
  credentials: types_1.FetchOptionCredentials.sameOrigin,
  mode: types_1.FetchOptionMode.sameOrigin
};
const defaultJsonOptions = {
  headers: {
    [types_1.HTTPHeader.accept]: [types_1.HTTPContentType.json, types_1.HTTPContentType.jsonApi].join(', ')
  }
};
function setDefaultOptions(options) {
  return Object.assign(defaultOptions, options);
}
exports.setDefaultOptions = setDefaultOptions;
function getDefaultOptions() {
  return defaultOptions;
}
exports.getDefaultOptions = getDefaultOptions;
function getDefaultJsonOptions() {
  return defaultJsonOptions;
}
exports.getDefaultJsonOptions = getDefaultJsonOptions;